/**
 * The collection of i18n strings.
 *
 * @since 0.5.0
 */
export const I18N = {
  playVideo: 'Play Video',
};
